import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {
    getLivedocCandidates,
    getLivedocCandidate,
    generateLivedoc
} from "../api/client";
import {Header} from "../components/Header";
import {setQueryString} from "../slices/usersSlice";
import {CenteredSpinner} from "../components/CenteredSpinner";
import {Button, Checkbox, Spinner} from "@seismic/mantle";

const Page = ({page, val, setCheckbox, selectedItems}) => {
    return <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
        <div style={{position: "relative"}}>
            <div style={{position: "absolute", left: 0, top: 0}}>
                <Checkbox checked={selectedItems.includes(val)} onChange={(e) => setCheckbox(e, val) }/>
            </div>
            <img style={{cursor: "pointer"}} width={192*2} height={108*2} loading="lazy" src={page.smallMediumThumbnailUrl} alt={page.name}/>
        </div>
    </div>
}

const GeneratedLiveDocModal = ({generatedLiveDoc}) => {
    return <div style={{display: "flex", flexDirection: "column", gap: 8, paddingTop: 16}}>
        <h3>New Deck</h3>
        {generatedLiveDoc.map((a, i)=><div style={{display: "flex", border: "1px solid #cfd4da", borderRadius: 4, padding: "8px", alignItems: "center", gap: 16}}>
            <div>Page {i+1}</div>
            <div style={{whiteSpace: "pre"}}>{a}</div>
        </div>)}
    </div>
}

export const LivedocGeneration = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const qsContentVersionId = urlParams.get('contentVersionId');
    const dispatch = useDispatch();
    const [contentVersionList, setContentVersionList] = useState([]);
    const [selectedContentVersionId, setSelectedContentVersionId] = useState(null);
    const [content, setContent] = useState(null);
    const [generatedLivedoc, setGeneratedLivedoc] = useState(null);
    const [generating, setGenerating] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    
    const getData = () => {
        let items = {};
        selectedItems.forEach((item) => {
            let [page, candidate] = item.split(".");
            if(items[page] === undefined)
                items[page] = [];
            if(candidate === undefined)
                items[page].push(content[parseInt(page)].extractedText);
            else
                items[page].push(content[parseInt(page)].candidates[parseInt(candidate)].extractedText);
        });
        let data = [];
        for(let key in items) {
            data.push({texts: items[key]});
        }
        return data;
    }
    const data = content === null ? [] : getData();
    
    useEffect(() => {
        getLivedocCandidates()
            .then(data => {
                setContentVersionList(data);
                if(data.filter(a=>a.id === qsContentVersionId).length > 0)
                    setSelectedContentVersionId(qsContentVersionId);
                else
                    setSelectedContentVersionId(data[0].id);
            })
    }, []);

    useEffect(() => {
        if (selectedContentVersionId === null)
            return;
        setContent(null);
        setGeneratedLivedoc(null);
        setSelectedItems([]);
        getLivedocCandidate(selectedContentVersionId)
            .then(data => {
                setContent(data);
            })
    }, [selectedContentVersionId]);
    
    const signOut = () => {
        dispatch(setAccessToken(null));
    }
    
    const generate = async () => {
        setGeneratedLivedoc(null);
        setGenerating(true);
        try {
            let response = await generateLivedoc({items: getData()});
            setGeneratedLivedoc(response);
        }
        finally{
            setGenerating(false);
        }
    }
    
    const setCheckbox = (e, value) => {
        if(e.target.checked)
            setSelectedItems([...selectedItems, value]);
        else
            setSelectedItems(selectedItems.filter(a=>a !== value));
    }

    return <>
        <Header signOut={signOut} title="Livedoc Generation" navigateTo="/LivedocGeneration" />
        <div style={{padding: "16px", position: "relative"}}>
            <div style={{paddingBottom: 16, display: "flex", alignItems: "center", gap: 8}}>
                <div>
                    <select value={selectedContentVersionId} onChange={(e) => {
                        setQueryString("contentVersionId", e.target.value);
                        setSelectedContentVersionId(e.target.value)
                    }
                    }>
                        {contentVersionList.map(item => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <Button disabled={generating} label={"Generate"} onClick={generate} endAdornment={generating && <Spinner/>} />

                </div>
            </div>
            {(content === null) && <CenteredSpinner />}
            {content && <div style={{display: "flex", flexDirection: "column", gap: 8}}>
                {content.map((page, i)=> <div style={{display: "flex", flexDirection: "row", border: "1px solid #cfd4da", borderRadius: 4, padding: "8px"}}>
                        <Page page={page} val={i.toString()} selectedItems={selectedItems} setCheckbox={setCheckbox} />
                        {page.candidates.map((candidate, j) =>
                            <Page page={candidate} val={`${i}.${j}`} selectedItems={selectedItems} setCheckbox={setCheckbox} />)}
                    </div>
                )}
            </div>}
            {generatedLivedoc && <GeneratedLiveDocModal generatedLiveDoc={generatedLivedoc} />}
        </div>
    </>;
}